'use strict';
const { io } = require('socket.io-client');

const TASKMANAGER_URL = `${window.location.protocol}//${window.location.hostname}:3023`;

const MAX_RECONNECT_ATTEMPTS = 3;

let socket = null;
let reconnectAttempts = 0;

/**
 * Retorna a instância singleton do socket conectado ao task manager.
 * A conexão é criada na primeira chamada, usando o userId do usuário logado.
 * Após 3 tentativas falhas consecutivas, a reconexão é desativada.
 */
function getTaskSocket() {
    if (!socket) {
        socket = io(TASKMANAGER_URL, {
            query: { userId: window.user.getIdPrefix() },
            auth: { apiKey: window.taskManagerApiKey ?? '' },
            transports: ['websocket'],
            reconnection: true,
            reconnectionAttempts: MAX_RECONNECT_ATTEMPTS,
        });

        socket.on('connect', () => {
            reconnectAttempts = 0;
        });

        socket.on('connect_error', (err) => {
            reconnectAttempts++;
            if (reconnectAttempts >= MAX_RECONNECT_ATTEMPTS) {
                console.error('[TaskManager] Erro de conexão:', err.message);
                socket.io.reconnection(false);
            }
        });
    }
    return socket;
}

module.exports = { getTaskSocket };
